module.exports = __webpack_public_path__ + "static/img/MP@3x.be063f8a.jpg";